/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "ll3q");
/******/ })
/************************************************************************/
/******/ ({

/***/ "6dB8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C7vi":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "ECJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F+rK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("Lt47");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/style.css
var style = __webpack_require__("qNvi");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/form_row_style.css
var form_row_style = __webpack_require__("Lq60");
var form_row_style_default = /*#__PURE__*/__webpack_require__.n(form_row_style);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/node_modules/classnames/index.js
var classnames = __webpack_require__("C7vi");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/form_field_style.css
var form_field_style = __webpack_require__("ECJt");
var form_field_style_default = /*#__PURE__*/__webpack_require__.n(form_field_style);

// CONCATENATED MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/form_field.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = classnames_default.a.bind(form_field_style_default.a);

var form_field_FormField = function (_Component) {
	_inherits(FormField, _Component);

	function FormField() {
		var _temp, _this, _ret;

		_classCallCheck(this, FormField);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (newValue) {
			_this.props.validateAndStoreField(_this.props.field.mapping, newValue);
		}, _this.renderField = function (field, responses) {
			return _this.props.fieldTypeRenderer.renderField(_this.updateValue.bind(_this), field, responses);
		}, _this.renderValidationMessages = function (field, responses) {
			if (responses[field.mapping].validationErrors.length === 0) return null;
			var validationMessage = responses[field.mapping].validationErrors.reduce(function (tracer, validation) {
				return tracer + " " + validation.message;
			}, "");
			return Object(preact_min["h"])(
				'div',
				{ 'class': 'invalid-feedback' },
				validationMessage
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	FormField.prototype.render = function render(_ref, _ref2) {
		var field = _ref.field,
		    responses = _ref.responses;

		_objectDestructuringEmpty(_ref2);

		var sizeClass = cx([{
			field: true,
			Small: field.size === 'Small',
			Medium: field.size === 'Medium',
			Large: field.size === 'Large',
			XLarge: field.size === 'XLarge'
		}, field.customClasses]);
		return Object(preact_min["h"])(
			'div',
			{ 'class': sizeClass },
			Object(preact_min["h"])(
				'label',
				{ 'for': field.mapping },
				field.label
			),
			this.renderField(field, responses),
			this.renderValidationMessages(field, responses)
		);
	};

	return FormField;
}(preact_min["Component"]);


// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/submit_button_style.css
var submit_button_style = __webpack_require__("XiFP");
var submit_button_style_default = /*#__PURE__*/__webpack_require__.n(submit_button_style);

// CONCATENATED MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/submit_button.js


function submit_button__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function submit_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function submit_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function submit_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var submit_button_cx = classnames_default.a.bind(submit_button_style_default.a);

var _ref3 = Object(preact_min["h"])('input', { 'class': 'btn btn-primary', type: 'submit', value: 'Submitting', disabled: 'disabled' });

var submit_button_SubmitButton = function (_Component) {
	submit_button__inherits(SubmitButton, _Component);

	function SubmitButton() {
		submit_button__classCallCheck(this, SubmitButton);

		return submit_button__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SubmitButton.prototype.render = function render(_ref, _ref2) {
		var field = _ref.field,
		    submitting = _ref.submitting;

		submit_button__objectDestructuringEmpty(_ref2);

		var sizeClass = submit_button_cx({
			field: true,
			Small: field.size === 'Small',
			Medium: field.size === 'Medium',
			Large: field.size === 'Large',
			XLarge: field.size === 'XLarge',
			submitButtonContainer: true
		});
		var button = null;
		if (this.props.submitting) {
			button = _ref3;
		} else {
			button = Object(preact_min["h"])('input', { 'class': 'btn btn-primary', type: 'submit', value: field.label });
		}
		return Object(preact_min["h"])(
			'div',
			{ 'class': sizeClass },
			button
		);
	};

	return SubmitButton;
}(preact_min["Component"]);


// CONCATENATED MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/form_row.js


function form_row__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function form_row__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function form_row__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function form_row__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var form_row_FormRow = function (_Component) {
	form_row__inherits(FormRow, _Component);

	function FormRow() {
		form_row__classCallCheck(this, FormRow);

		return form_row__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FormRow.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var row = _ref.row,
		    responses = _ref.responses,
		    submitting = _ref.submitting,
		    fieldTypeRenderer = _ref.fieldTypeRenderer;

		form_row__objectDestructuringEmpty(_ref2);

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'flexRow' },
			row.fields.map(function (field) {
				if (field.type === "submit") return Object(preact_min["h"])(submit_button_SubmitButton, { field: field, submitting: _this2.props.submitting });
				return Object(preact_min["h"])(form_field_FormField, { field: field, validateAndStoreField: _this2.props.validateAndStoreField, responses: responses, fieldTypeRenderer: fieldTypeRenderer });
			})
		);
	};

	return FormRow;
}(preact_min["Component"]);


// CONCATENATED MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/index.js
var _class, _temp2, _initialiseProps;



function form__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function form__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function form__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function form__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var form_Form = (_temp2 = _class = function (_Component) {
	form__inherits(Form, _Component);

	function Form() {
		var _temp, _this, _ret;

		form__classCallCheck(this, Form);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = form__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), form__possibleConstructorReturn(_this, _ret);
	}

	Form.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var formStructure = _ref.formStructure,
		    fieldTypeRenderer = _ref.fieldTypeRenderer;

		form__objectDestructuringEmpty(_ref2);

		return this.state.submitted ? Object(preact_min["h"])(
			'div',
			null,
			formStructure.info.submissionText
		) : Object(preact_min["h"])(
			'form',
			{ 'class': 'inquiryFormContainer', onSubmit: this.attemptSubmit },
			formStructure.layout.rows.map(function (row) {
				return Object(preact_min["h"])(form_row_FormRow, { row: row, validateAndStoreField: _this2.validateAndStoreField, responses: _this2.state.formResponses, submitting: _this2.state.submitting, fieldTypeRenderer: fieldTypeRenderer });
			})
		);
	};

	return Form;
}(preact_min["Component"]), _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.initializeFormResponses = function () {
		var responses = {};
		Object.keys(_this3.props.formStructure.fields).forEach(function (field) {
			responses[field] = { value: '', validationErrors: [] };
		});
		return responses;
	};

	this.state = { formResponses: this.initializeFormResponses(), submitted: false };

	this.runValidations = function (fieldKey, value) {
		var validationErrors = [];
		_this3.props.formStructure.fields[fieldKey].validations.forEach(function (item, index) {
			switch (item.type) {
				case "required":
					if (value === "") {
						validationErrors.push(item);
					}
					break;
				case "dateinfuture":
					var dateValue = Date.parse(value);
					var nowDateTime = new Date();
					var nowDate = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate());
					if (nowDate > dateValue) {
						validationErrors.push(item);
					}
					break;
				case "regex":
					if (value === null || value === "") break;
					var pattern = new RegExp(item.pattern);
					var match = pattern.test(value);
					if (!match) {
						validationErrors.push(item);
					}
					break;
				case "maxLength":
					if (value === null || value === "") break;
					if (value.length > item.maxLength) {
						validationErrors.push(item);
					}
					break;
			}
		});
		return validationErrors;
	};

	this.validateAndStoreField = function (fieldKey, newValue) {
		var validationErrors = _this3.runValidations(fieldKey, newValue);
		var formResponses = _this3.state.formResponses;
		formResponses[fieldKey].value = newValue;
		formResponses[fieldKey].validationErrors = validationErrors;
		_this3.setState({ formResponses: formResponses });
	};

	this.formJSONArgs = function () {
		var args = {};
		// Form identifying info
		args['formKey'] = _this3.props.formStructure.info.formKey;

		// Form response
		Object.keys(_this3.state.formResponses).forEach(function (fieldKey) {
			args[fieldKey] = _this3.state.formResponses[fieldKey].value;
		});

		return args;
	};

	this.attemptSubmit = function (e) {
		e.preventDefault();
		_this3.setState({ submitting: true });
		// check all fields for validations
		var responses = _this3.state.formResponses;
		Object.keys(_this3.props.formStructure.fields).forEach(function (fieldKey) {
			responses[fieldKey].validationErrors = _this3.runValidations(fieldKey, responses[fieldKey].value);
		});
		// if any validation errors are present then stop
		var errorCount = Object.keys(responses).reduce(function (sum, response) {
			return sum + responses[response].validationErrors.length;
		}, 0);
		if (errorCount === 0) {
			// submit that thing
			var body = _this3.formJSONArgs();
			var endpoint = _this3.props.formStructure.info.apiEndpoint;
			var result = fetch('' + endpoint, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'appKey': _this3.props.formStructure.info.appKey,
					'clientKey': _this3.props.formStructure.info.clientKey,
					'formId': _this3.props.formStructure.info.formId
				},
				body: JSON.stringify(body),
				credentials: 'include' }).then(function (response) {
				if (_this3.props.formStructure.info.redirectUrl === '') {
					_this3.setState({ submitted: true });
				} else {
					window.top.location = _this3.props.formStructure.info.redirectUrl;
				}
			});
		} else {
			// there were errors
			console.log("errors so not submitting");
			_this3.setState({ submitting: false });
		}
		_this3.setState({ formResponses: responses });
	};
}, _temp2);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/manaaki/style.css
var manaaki_style = __webpack_require__("pMGc");
var manaaki_style_default = /*#__PURE__*/__webpack_require__.n(manaaki_style);

// CONCATENATED MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/manaaki/form_structure.js


var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [{ type: 'required', message: 'Please provide a first name' }]
    },
    lastName: {
      validations: [{ type: 'required', message: 'Please provide a last name' }]
    },
    telnumber: {
      validations: [{ type: 'required', message: 'Please provide a telephone number' }, { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }]
    },
    email: {
      validations: [{ type: 'required', message: 'Please provide an email' }, { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }]
    },
    clientname: {
      validations: [{ type: 'required', message: 'Please provide a company name' }]
    },
    plannedguestcount: {
      validations: []
    },
    theme: {
      validations: [{ type: 'required', message: 'Please provide the type of event' }]
    },
    sitename: {
      validations: []
    },
    notes: {
      validations: [{ type: 'required', message: 'Please provide details' }]
    },
    eventDate: {
      validations: [{ type: 'required', message: 'Please select a date for your event' }, { type: 'dateinfuture', message: 'Event date must be in the future' }]
    },
    starttime: {
      validations: [{ type: 'required', message: 'Please provide an access time' }]
    },
    endtime: {
      validations: [{ type: 'required', message: 'Please provide a finish time' }]
    },
    eventextra3: {
      validations: []
    },
    eventextra4: {
      validations: []
    },
    eventextra5: {
      validations: []
    },
    eventextra6: {
      validations: []
    },
    eventextra7: {
      validations: []
    }
  },
  layout: {
    rows: [{
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'First Name*',
        mapping: 'firstName'
      }, {
        type: 'text',
        size: 'Medium',
        label: 'Last Name*',
        mapping: 'lastName'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Number*',
        mapping: 'telnumber'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Email*',
        mapping: 'email'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Company name*',
        mapping: 'clientname'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Number of people',
        mapping: 'plannedguestcount'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Type of event*',
        mapping: 'theme'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Preferred Room',
        mapping: 'sitename'
      }]
    }, {
      fields: [{
        type: 'text-area',
        size: 'Medium',
        label: 'Catering Requirements*',
        mapping: 'notes'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Room Set Preference',
        mapping: 'eventextra3'
      }]
    }, {
      fields: [{
        type: 'date-picker',
        size: 'Medium',
        label: 'What date are you interested in?*',
        mapping: 'eventDate'
      }]
    }, {
      fields: [{
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Access Time*',
        options: [{ label: '6:00AM', value: '06:00:00' }, { label: '6:30AM', value: '06:30:00' }, { label: '7:00AM', value: '07:00:00' }, { label: '7:30AM', value: '07:30:00' }, { label: '8:00AM', value: '08:00:00' }, { label: '8:30AM', value: '08:30:00' }, { label: '9:00AM', value: '09:00:00' }, { label: '9:30AM', value: '09:30:00' }, { label: '10:00AM', value: '10:00:00' }, { label: '10:30AM', value: '10:30:00' }, { label: '11:00AM', value: '11:00:00' }, { label: '11:30AM', value: '11:30:00' }, { label: '12:00PM', value: '12:00:00' }, { label: '12:30PM', value: '12:30:00' }, { label: '1:00PM', value: '13:00:00' }, { label: '1:30PM', value: '13:30:00' }, { label: '2:00PM', value: '14:00:00' }, { label: '2:30PM', value: '14:30:00' }, { label: '3:00PM', value: '15:00:00' }, { label: '3:30PM', value: '15:30:00' }, { label: '4:00PM', value: '16:00:00' }, { label: '4:30PM', value: '16:30:00' }, { label: '5:00PM', value: '17:00:00' }, { label: '5:30PM', value: '17:30:00' }, { label: '6:00PM', value: '18:00:00' }, { label: '6:30PM', value: '18:30:00' }, { label: '7:00PM', value: '19:00:00' }, { label: '7:30PM', value: '19:30:00' }, { label: '8:00PM', value: '20:00:00' }, { label: '8:30PM', value: '20:30:00' }, { label: '9:00PM', value: '21:00:00' }, { label: '9:30PM', value: '21:30:00' }, { label: '10:00PM', value: '22:00:00' }, { label: '10:30PM', value: '22:30:00' }, { label: '11:00PM', value: '23:00:00' }, { label: '11:30PM', value: '23:30:00' }, { label: '12:00AM', value: '24:00:00' }, { label: '12:30AM', value: '24:30:00' }, { label: '1:00AM', value: '01:00:00' }, { label: '1:30AM', value: '01:30:00' }, { label: '2:00AM', value: '02:00:00' }],
        mapping: 'starttime'
      }, {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Finish Time*',
        options: [{ label: '6:00AM', value: '06:00:00' }, { label: '6:30AM', value: '06:30:00' }, { label: '7:00AM', value: '07:00:00' }, { label: '7:30AM', value: '07:30:00' }, { label: '8:00AM', value: '08:00:00' }, { label: '8:30AM', value: '08:30:00' }, { label: '9:00AM', value: '09:00:00' }, { label: '9:30AM', value: '09:30:00' }, { label: '10:00AM', value: '10:00:00' }, { label: '10:30AM', value: '10:30:00' }, { label: '11:00AM', value: '11:00:00' }, { label: '11:30AM', value: '11:30:00' }, { label: '12:00PM', value: '12:00:00' }, { label: '12:30PM', value: '12:30:00' }, { label: '1:00PM', value: '13:00:00' }, { label: '1:30PM', value: '13:30:00' }, { label: '2:00PM', value: '14:00:00' }, { label: '2:30PM', value: '14:30:00' }, { label: '3:00PM', value: '15:00:00' }, { label: '3:30PM', value: '15:30:00' }, { label: '4:00PM', value: '16:00:00' }, { label: '4:30PM', value: '16:30:00' }, { label: '5:00PM', value: '17:00:00' }, { label: '5:30PM', value: '17:30:00' }, { label: '6:00PM', value: '18:00:00' }, { label: '6:30PM', value: '18:30:00' }, { label: '7:00PM', value: '19:00:00' }, { label: '7:30PM', value: '19:30:00' }, { label: '8:00PM', value: '20:00:00' }, { label: '8:30PM', value: '20:30:00' }, { label: '9:00PM', value: '21:00:00' }, { label: '9:30PM', value: '21:30:00' }, { label: '10:00PM', value: '22:00:00' }, { label: '10:30PM', value: '22:30:00' }, { label: '11:00PM', value: '23:00:00' }, { label: '11:30PM', value: '23:30:00' }, { label: '12:00AM', value: '24:00:00' }, { label: '12:30AM', value: '24:30:00' }, { label: '1:00AM', value: '01:00:00' }, { label: '1:30AM', value: '01:30:00' }, { label: '2:00AM', value: '02:00:00' }],
        mapping: 'endtime'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'AV requirement',
        mapping: 'eventextra4'
      }]
    }, {
      fields: [{
        type: 'radio-buttons',
        size: 'Medium',
        label: 'Require Wi-Fi?',
        options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }],
        mapping: 'eventextra5'
      }]
    }, {
      fields: [{
        type: 'radio-buttons',
        size: 'Medium',
        label: 'Require tablecloths?',
        options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }],
        mapping: 'eventextra6'
      }]
    }, {
      fields: [{
        type: 'radio-buttons',
        size: 'Medium',
        label: 'Interested in cultural engagement?',
        options: [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }],
        mapping: 'eventextra7'
      }]
    }, {
      fields: [{
        type: 'submit',
        size: 'Medium',
        label: 'SEND'
      }]
    }]
  },
  info: {
    title: 'Manaaki Management Contact Form',
    formId: '166',
    clientKey: '2415BF26-C9CB-4C01-8162-A2EB4D69FADB',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Kia ora – your request has been submitted, we will be in contact. Ngā mihi – The Wellington Functions Team',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};

/* harmony default export */ var form_structure = (FormStructure);
// CONCATENATED MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/includes.js



/* harmony default export */ var includes = (form_structure);
// EXTERNAL MODULE: ./field_types/text_field_style.css
var text_field_style = __webpack_require__("PkpO");
var text_field_style_default = /*#__PURE__*/__webpack_require__.n(text_field_style);

// CONCATENATED MODULE: ./field_types/text_field.js


function text_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function text_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function text_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function text_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var text_field_TextField = function (_Component) {
  text_field__inherits(TextField, _Component);

  function TextField() {
    var _temp, _this, _ret;

    text_field__classCallCheck(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = text_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      console.log(_this.props);
      _this.props.updateValue(e.target.value);
    }, _temp), text_field__possibleConstructorReturn(_this, _ret);
  }

  TextField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid;

    text_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])('input', { id: field.mapping, name: field.mapping, type: 'text', size: '20', placeholder: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return TextField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/multiple_choice_field_style.css
var multiple_choice_field_style = __webpack_require__("yeEv");
var multiple_choice_field_style_default = /*#__PURE__*/__webpack_require__.n(multiple_choice_field_style);

// CONCATENATED MODULE: ./field_types/multiple_choice_field.js


function multiple_choice_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function multiple_choice_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function multiple_choice_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function multiple_choice_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var multiple_choice_field__ref3 = Object(preact_min["h"])(
  'option',
  { selected: true },
  'Choose an option'
);

var multiple_choice_field_MultipleChoiceField = function (_Component) {
  multiple_choice_field__inherits(MultipleChoiceField, _Component);

  function MultipleChoiceField() {
    var _temp, _this, _ret;

    multiple_choice_field__classCallCheck(this, MultipleChoiceField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = multiple_choice_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), multiple_choice_field__possibleConstructorReturn(_this, _ret);
  }

  MultipleChoiceField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid,
        responses = _ref.responses;

    multiple_choice_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'custom-select': true,
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'select',
      { id: field.mapping, name: field.mapping, 'class': classes, onChange: this.updateValue },
      multiple_choice_field__ref3,
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'option',
          { value: option.value },
          option.label
        );
      })
    );
  };

  return MultipleChoiceField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/date_picker_field_style.css
var date_picker_field_style = __webpack_require__("VU9e");
var date_picker_field_style_default = /*#__PURE__*/__webpack_require__.n(date_picker_field_style);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/node_modules/pikaday/pikaday.js
var pikaday = __webpack_require__("ksyN");
var pikaday_default = /*#__PURE__*/__webpack_require__.n(pikaday);

// EXTERNAL MODULE: /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/node_modules/pikaday/css/pikaday.css
var css_pikaday = __webpack_require__("F+rK");
var css_pikaday_default = /*#__PURE__*/__webpack_require__.n(css_pikaday);

// CONCATENATED MODULE: ./field_types/date_picker_field.js


function date_picker_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function date_picker_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function date_picker_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function date_picker_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var date_picker_field_DatePickerField = function (_Component) {
  date_picker_field__inherits(DatePickerField, _Component);

  function DatePickerField() {
    var _temp, _this, _ret;

    date_picker_field__classCallCheck(this, DatePickerField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = date_picker_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), date_picker_field__possibleConstructorReturn(_this, _ret);
  }

  DatePickerField.prototype.componentDidMount = function componentDidMount() {
    new pikaday_default.a({ field: this.base });
  };

  DatePickerField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        response = _ref.response,
        isValid = _ref.isValid;

    date_picker_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    var selectedDate = null;

    return Object(preact_min["h"])('input', { id: field.mapping, name: field.mapping, placeholder: field.label, 'class': 'form-control', onBlur: this.updateValue });
  };

  return DatePickerField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/checkbox_field_style.css
var checkbox_field_style = __webpack_require__("6dB8");
var checkbox_field_style_default = /*#__PURE__*/__webpack_require__.n(checkbox_field_style);

// CONCATENATED MODULE: ./field_types/checkbox_field.js


function checkbox_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function checkbox_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function checkbox_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function checkbox_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var checkbox_field_CheckboxField = function (_Component) {
  checkbox_field__inherits(CheckboxField, _Component);

  function CheckboxField() {
    var _temp, _this, _ret;

    checkbox_field__classCallCheck(this, CheckboxField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = checkbox_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), checkbox_field__possibleConstructorReturn(_this, _ret);
  }

  CheckboxField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid;

    checkbox_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])('input', { name: field.mapping, type: 'checkbox', value: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return CheckboxField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/text_area_field_style.css
var text_area_field_style = __webpack_require__("bAlB");
var text_area_field_style_default = /*#__PURE__*/__webpack_require__.n(text_area_field_style);

// CONCATENATED MODULE: ./field_types/text_area_field.js


function text_area_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function text_area_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function text_area_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function text_area_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var text_area_field_TextAreaField = function (_Component) {
  text_area_field__inherits(TextAreaField, _Component);

  function TextAreaField() {
    var _temp, _this, _ret;

    text_area_field__classCallCheck(this, TextAreaField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = text_area_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), text_area_field__possibleConstructorReturn(_this, _ret);
  }

  TextAreaField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid;

    text_area_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])('textarea', { id: field.mapping, name: field.mapping, rows: '5', placeholder: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return TextAreaField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/radio_button_field_style.css
var radio_button_field_style = __webpack_require__("Rrdc");
var radio_button_field_style_default = /*#__PURE__*/__webpack_require__.n(radio_button_field_style);

// CONCATENATED MODULE: ./field_types/radio_button_field.js


function radio_button_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function radio_button_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function radio_button_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function radio_button_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var radio_button_field_RadioButtonField = function (_Component) {
  radio_button_field__inherits(RadioButtonField, _Component);

  function RadioButtonField() {
    var _temp, _this, _ret;

    radio_button_field__classCallCheck(this, RadioButtonField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = radio_button_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), radio_button_field__possibleConstructorReturn(_this, _ret);
  }

  RadioButtonField.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var field = _ref.field,
        isValid = _ref.isValid,
        responses = _ref.responses;

    radio_button_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'div',
      null,
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'div',
          { 'class': 'form-check' },
          Object(preact_min["h"])(
            'label',
            { 'class': 'form-check-label' },
            Object(preact_min["h"])('input', { 'class': 'form-check-input', type: 'radio', name: field.mapping, value: option.value, onChange: _this2.updateValue }),
            option.label
          )
        );
      })
    );
  };

  return RadioButtonField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/checkbox_list_style.css
var checkbox_list_style = __webpack_require__("VaZr");
var checkbox_list_style_default = /*#__PURE__*/__webpack_require__.n(checkbox_list_style);

// CONCATENATED MODULE: ./field_types/checkbox_list.js


function checkbox_list__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function checkbox_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function checkbox_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function checkbox_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var checkbox_list_CheckboxList = function (_Component) {
  checkbox_list__inherits(CheckboxList, _Component);

  function CheckboxList() {
    var _temp, _this, _ret;

    checkbox_list__classCallCheck(this, CheckboxList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = checkbox_list__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidMount = function () {
      _this.selectedCheckboxes = new Set();
    }, _this.updateValue = function (e) {
      var val = e.target.value;
      if (_this.selectedCheckboxes.has(val)) {
        _this.selectedCheckboxes.delete(val);
      } else {
        _this.selectedCheckboxes.add(val);
      }
      _this.props.updateValue(Array.from(_this.selectedCheckboxes).join());
    }, _temp), checkbox_list__possibleConstructorReturn(_this, _ret);
  }

  CheckboxList.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var field = _ref.field,
        isValid = _ref.isValid;

    checkbox_list__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'div',
      null,
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'div',
          { 'class': 'form-check' },
          Object(preact_min["h"])(
            'label',
            { 'class': 'form-check-label' },
            Object(preact_min["h"])('input', { 'class': 'form-check-input', type: 'checkbox', name: field.mapping, value: option.value, onChange: _this2.updateValue }),
            option.label
          )
        );
      })
    );
  };

  return CheckboxList;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./field_type_renderer.js


function field_type_renderer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }











var field_type_renderer__ref = Object(preact_min["h"])(
	'div',
	null,
	'Unmapped field type'
);

var field_type_renderer_FieldTypeRenderer = function FieldTypeRenderer() {
	field_type_renderer__classCallCheck(this, FieldTypeRenderer);

	this.renderField = function (updateValue, field, responses) {
		console.log([updateValue, field, responses]);
		switch (field.type) {
			case 'label':
				return null;
			case 'text':
				return Object(preact_min["h"])(text_field_TextField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'multiple-choice':
				return Object(preact_min["h"])(multiple_choice_field_MultipleChoiceField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'date-picker':
				return Object(preact_min["h"])(date_picker_field_DatePickerField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'checkbox':
				return Object(preact_min["h"])(checkbox_field_CheckboxField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'text-area':
				return Object(preact_min["h"])(text_area_field_TextAreaField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'checkbox-list':
				return Object(preact_min["h"])(checkbox_list_CheckboxList, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'radio-buttons':
				return Object(preact_min["h"])(radio_button_field_RadioButtonField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
		}
		return field_type_renderer__ref;
	};
};


// EXTERNAL MODULE: ./index.css
var index = __webpack_require__("xHuH");
var index_default = /*#__PURE__*/__webpack_require__.n(index);

// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return index_App; });


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var index_App = function (_Component) {
	index__inherits(App, _Component);

	function App() {
		var _temp, _this, _ret;

		index__classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = index__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { formStructure: includes }, _temp), index__possibleConstructorReturn(_this, _ret);
	}

	App.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ id: 'app' },
			Object(preact_min["h"])(form_Form, { formStructure: this.state.formStructure, fieldTypeRenderer: new field_type_renderer_FieldTypeRenderer() })
		);
	};

	return App;
}(preact_min["Component"]);



/***/ }),

/***/ "Lq60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lt47":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "PkpO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rrdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VU9e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VaZr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XiFP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bAlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ksyN":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory) {
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try {
            moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
        } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req) {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try {
                moment = req(id);
            } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
})(this, function (moment) {
    'use strict';

    /**
     * feature detection and helper functions
     */

    var hasMoment = typeof moment === 'function',
        hasEventListeners = !!window.addEventListener,
        document = window.document,
        sto = window.setTimeout,
        addEvent = function addEvent(el, e, callback, capture) {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },
        removeEvent = function removeEvent(el, e, callback, capture) {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },
        trim = function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    },
        hasClass = function hasClass(el, cn) {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },
        addClass = function addClass(el, cn) {
        if (!hasClass(el, cn)) {
            el.className = el.className === '' ? cn : el.className + ' ' + cn;
        }
    },
        removeClass = function removeClass(el, cn) {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },
        isArray = function isArray(obj) {
        return (/Array/.test(Object.prototype.toString.call(obj))
        );
    },
        isDate = function isDate(obj) {
        return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
        );
    },
        isWeekend = function isWeekend(date) {
        var day = date.getDay();
        return day === 0 || day === 6;
    },
        isLeapYear = function isLeapYear(year) {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },
        getDaysInMonth = function getDaysInMonth(year, month) {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },
        setToStartOfDay = function setToStartOfDay(date) {
        if (isDate(date)) date.setHours(0, 0, 0, 0);
    },
        compareDates = function compareDates(a, b) {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },
        extend = function extend(to, from, overwrite) {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                } else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },
        fireEvent = function fireEvent(el, eventName, data) {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },
        adjustCalendar = function adjustCalendar(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month) / 12);
            calendar.month -= 12;
        }
        return calendar;
    },


    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect: true,

        // internationalization
        i18n: {
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function renderDayName(opts, day, abbr) {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },
        renderDay = function renderDay(opts) {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if (!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }
            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' + '<button class="pika-button pika-day" type="button" ' + 'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' + opts.day + '</button>' + '</td>';
    },
        renderWeek = function renderWeek(d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil(((new Date(y, m, d) - onejan) / 86400000 + onejan.getDay() + 1) / 7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },
        renderRow = function renderRow(days, isRTL, pickWholeWeek, isRowSelected) {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },
        renderBody = function renderBody(rows) {
        return '<tbody>' + rows.join('') + '</tbody>';
    },
        renderHead = function renderHead(opts) {
        var i,
            arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },
        renderTitle = function renderTitle(instance, c, year, month, refYear, randId) {
        var i,
            j,
            arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"' : '') + '>' + i + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === instance._o.numberOfMonths - 1) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },
        renderTable = function renderTable(opts, data, randId) {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function Pikaday(options) {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function (e) {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function () {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                } else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                } else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function (e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            } else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function (e) {
            e = e || window.event;

            if (self.isVisible()) {

                switch (e.keyCode) {
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function (e) {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (opts.parse) {
                date = opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = date && date.isValid() ? date.toDate() : null;
            } else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
                self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function () {
            self.show();
        };

        self._onInputClick = function () {
            self.show();
        };

        self._onInputBlur = function () {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            } while (pEl = pEl.parentNode);

            if (!self._c) {
                self._b = sto(function () {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function (e) {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            } while (pEl = pEl.parentNode);
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };

    /**
     * public Pikaday API
     */
    Pikaday.prototype = {

        /**
         * configure functionality
         */
        config: function config(options) {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = opts.field && opts.field.nodeName ? opts.field : null;

            opts.theme = typeof opts.theme === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = opts.trigger && opts.trigger.nodeName ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = typeof opts.disableDayFn === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if (opts.minDate && opts.maxDate && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function toString(format) {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
                return this._o.toString(this._d, format);
            }
            if (hasMoment) {
                return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function getMoment() {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function setMoment(date, preventOnSelect) {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function getDate() {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function setDate(date, preventOnSelect) {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function gotoDate(date) {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
                lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
                newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function adjustDate(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days) * 24 * 60 * 60 * 1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function adjustCalendars() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function gotoToday() {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function gotoMonth(month) {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function nextMonth() {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function prevMonth() {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function gotoYear(year) {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function setMinDate(value) {
            if (value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function setMaxDate(value) {
            if (value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function setStartRange(value) {
            this._o.startRange = value;
        },

        setEndRange: function setEndRange(value) {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function draw(force) {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if (opts.field.type !== 'hidden') {
                    sto(function () {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function adjustPosition() {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top = pEl.offsetTop + pEl.offsetHeight;
                while (pEl = pEl.offsetParent) {
                    left += pEl.offsetLeft;
                    top += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if (this._o.reposition && left + width > viewportWidth || this._o.position.indexOf('right') > -1 && left - width + field.offsetWidth > 0) {
                left = left - width + field.offsetWidth;
            }
            if (this._o.reposition && top + height > viewportHeight + scrollTop || this._o.position.indexOf('top') > -1 && top - height - field.offsetHeight > 0) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function render(year, month, randId) {
            var opts = this._o,
                now = new Date(),
                days = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data = [],
                row = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while (after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++) {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= days + before,
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                    day: dayNumber,
                    month: monthNumber,
                    year: yearNumber,
                    hasEvent: hasEvent,
                    isSelected: isSelected,
                    isToday: isToday,
                    isDisabled: isDisabled,
                    isEmpty: isEmpty,
                    isStartRange: isStartRange,
                    isEndRange: isEndRange,
                    isInRange: isInRange,
                    showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                    enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function isVisible() {
            return this._v;
        },

        show: function show() {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function hide() {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function destroy() {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
});

/***/ }),

/***/ "ll3q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("Lt47");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "pMGc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qNvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xHuH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yeEv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.bc4ac.js